/**
 * Repair a funnel-supplied `?email=` query param that lost its `+` to
 * form-urlencoded decoding.
 *
 * GHL substitutes `{{contact.email}}` into the funnel form's redirect URL raw,
 * with no percent-encoding, so a plus-addressed email reaches /signup as a
 * literal `+` in the query string — which the router's parser (URLSearchParams,
 * spec-correct for application/x-www-form-urlencoded) decodes as a space:
 * `?email=jane+doe@gmail.com` → "jane doe@gmail.com". That corrupted value then
 * pre-fills the form AND gets recorded as `funnel_email` /
 * `user_profiles.referral_signup_email`, where the GHL sale sync uses it to find
 * the funnel's contact — a lookup that can never match, and a false
 * "funnel email differs" divergence written to the CRM.
 *
 * A real email can never contain a space, so every INTERIOR space here is a `+`
 * that lost its encoding — mapping spaces back to `+` is lossless for this
 * param (and only this param: names legitimately contain spaces). Values that
 * arrive properly encoded (`%2B`) decode to `+` on their own and pass through
 * untouched, as does everything our own code round-trips (the OAuth
 * `funnel_email` carrier percent-encodes).
 *
 * Trim first: `%20` padding around the address must not become a leading or
 * trailing `+`.
 */
export function repairFunnelEmail(value: string | undefined): string | undefined {
  if (value === undefined) return undefined;
  return value.trim().replace(/ /g, '+');
}
